module.exports = __webpack_public_path__ + "static/comunication-image-e854d2a90180ed3b3e6001243ddba41d.png";